export interface ICommand { }

export class CreateRevenueAccountCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Revenues.Commands.CreateRevenueAccountCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Revenues.Commands.CreateRevenueAccountCommandV1, TCh.Domain.Quest'
	}

}

export class DeleteRevenueAccountCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Revenues.Commands.DeleteRevenueAccountCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string

	constructor (workspaceId: number, strategyId: string, id: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Revenues.Commands.DeleteRevenueAccountCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateRevenueAccountCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Revenues.Commands.UpdateRevenueAccountCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Revenues.Commands.UpdateRevenueAccountCommandV1, TCh.Domain.Quest'
	}

}

